import Vue from "vue";
import store from "../store";
import FlightSearch from "@/services/FlightSearch";
import EditBooking from "@/services/EditBooking";
import { EventBus } from "@/services/EventBus.js";
import User from "@/services/User";
import Payment from "@/services/Payment";
import dayjs from "dayjs";
const isBetween = require("dayjs/plugin/isBetween");
const isSameOrBefore = require("dayjs/plugin/isSameOrBefore");
const isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import { createHelpers } from "vuex-map-fields";
// import { isNumber } from "util";
// import { futimesSync } from "fs";
// import { Server } from "https";
const { mapFields } = createHelpers({
  getterType: "getField",
  mutationType: "updateField"
});
Vue.use(Vuex);
const getters = {
  getField
};
const mutations = {
  updateField
};

const flightsDepartingParams = {
  dir: "D",
  flight_type: "departing"
};

const flightsReturningParams = {
  dir: "R",
  flight_type: "returning"
};

let currentLowestFareBaseDate = null;

function passengerTypes() {
  this.Adult = Array();
  this.Child = Array();
  this.Infant = Array();
}

let passCount = 0;
function addPassengerPlaceholder(dir, index) {
  this.id = index;
  this.id = passCount;
  this.type = dir;
  this.fname = "";
  this.lname = "";
  this.gender = "";
  this.discounts = [
    {
      name: "Student",
      value: false
    },
    {
      name: "Senior",
      value: false
    }
  ];
  passCount++;
}

export default {
  name: "Shared",
  store: store,
  getters: getters,
  mutations: mutations,
  data: function() {
    return {
      rules: {
        required: value => !!value || "Required",
        minText: value => (value != null && value.length > 1) || "Incomplete",
        month: value => (value > 0 && value <= 12) || "Invalid Month",
        year: value => (value >= 20 && value <= 50) || "Invalid Year",
        phone: value => (this.validatePhoneNumber(value)) || "Invalid Phone Number",
        email: value => (this.validateEmail(value)) || "Invalid Email Address"
      },
      passengerDiscounts: [],
      countdownTimer: ""
    };
  },
  computed: {
    ...mapFields([
      "complete",
      "editMode",
      "form_fields.b_id",
      "loading",
      "loading2",
      "loadingUser",
      "mobileDevice",
      "showCountdownTimer",
      "minMode",
      "showForm",
      "form",
      "errors",
      "active",
      "locations",
      "form_fields",
      "form_fields.use_prepaid",
      "form_fields.agree_to_terms",
      "form_fields.dep_loc",
      "form_fields.dest_loc",
      "form_fields.dep_date",
      "form_fields.ret_date",
      "form_fields.pax_a",
      "form_fields.pax_c",
      "form_fields.pax_i",
      "form_fields.pax_a_r",
      "form_fields.pax_c_r",
			"form_fields.pax_i_r",
			"form_fields.hcaptchaToken",
      "departFlight",
      "departingFlights",
      "returnFlight",
      "returningFlights",
      "samepassengers",
      "form_fields.round_trip",
      "user",
      "user.email",
      "user.phone",
      "user.phone.alt",
      "user.phone.cell",
      "user.password",
      "user.address",
      "user.address.city",
      "user.address.country",
      "user.address.postal_code",
      "user.address.province",
      "user.address.street",
      "user.address.street2",
      "user.credit_card",
      "user.credit_card.number",
      "user.credit_card.cardholder_fn",
      "user.credit_card.cardholder_ln",
      "user.credit_card.cvv",
      "user.credit_card.expires",
      "user.credit_card.expires.mm",
			"user.credit_card.expires.yy",
			"user.promocode",
      "conditions",
      "conditions.senior",
      "conditions.student",
      "line_items",
      "line_items.terms",
      "editBookingData"
    ]),
    session_start_time() {
      return dayjs(store.state.timer).format("h:mm:ss a");
    },
    session_end_time() {
      return dayjs(store.state.timer)
        .add(
          store.state.timeLimit.value,
          store.state.timeLimit.scale
        )
        .format("h:mm:ss a");
    },
    session_current_time() {
      if (store.state.timer !== null) {
        const tLimit = dayjs(store.state.timer)
          .add(
            store.state.timeLimit.value,
            store.state.timeLimit.scale
          );
        const now = dayjs();
        const diff = tLimit.diff(now, "minute");
        return diff;
      }
      return 0;
    },
    session_current_second() {
      if (store.state.timer !== null) {
        let rT = this.getRemainingTime();
        const tLimit = dayjs(store.state.timer)
          .add(
            store.state.timeLimit.value,
            store.state.timeLimit.scale
          );
        const now = dayjs();
        const diff = tLimit.diff(now, "seconds");
        if (diff <= 0 && this.complete === false) {
          console.log("Form timeout. Clearing form data...");
          this.resetForm();
        }
        return diff;
      }
      return 0;
    },
    min_mode() {
      return store.state.minMode;
    },
    col_mode() {
      return store.state.colMode;
    },
    has_prepaid() {
      return store.state.user.has_prepaid;
    },
    messageClass() {
      return {
        invalid: this.hasMessages
      };
    },
    roundTrip: {
      get() {
        if (this.ret_date === null && this.calRet == false) return false;
        else return true;
      },
      set(value) {
        this.setReturn(value);
      }
    },
    formattedDate() {
      return dayjs(this).format("yyyy-mm-dd");
    },
    datePickerFormattedDate() {
      return dayjs(this).format("yyyy-mm-dd");
    },
    depDateRules: {
      get() {
        return [
          v => !!v || "Date is required",
          v =>
            dayjs(v).isSameOrAfter(dayjs(), "day") || "Date must be in the future",
          v =>
            dayjs(v).isBefore(dayjs().add("1", "year")) ||
            "Date must be within the next year"
        ];
      }
    },
    retDateRules: {
      get() {
        return [
          v =>
            dayjs(v).isSameOrAfter(dayjs(), "day") || "Date must be in the future",
          v =>
            dayjs(v).isBefore(dayjs().add("1", "year")) ||
            "Date must be within the next year"
        ];
      }
    },
    paxTerm() {
      return this.findPaxTerm();
    },
    displayErrors: {
      get() {
        let step = this.active;
        let sec = this.form;
        let form = sec[step - 1];
        let cErrors = [];
        if (form.meta.fields != undefined) {
          form.meta.fields.forEach(f => {
            if (f.status.error === true) {
              cErrors.push(f.status.errorDetails);
            }
          });
        } else if (form.meta.status.error === true) {
          cErrors.push(form.meta.status.errorDetails);
        }
        return cErrors;
      },
      set() {
        return;
      }
    },
    returnError() {
      return this.showError;
    },
    flightType() {
      if (this.searchType == "departing") return "departing";
      else return "returning";
    },
    theseFlights() {
      const flights = this.searchType + "Flights";
      if (this[flights] !== null && this[flights].length > 0) {
        return this[flights];
      } else {
        return null;
      }
    },
    getSelFareType() {
      let type = "departing";
      if (this.active === 2) {
        type = "returning";
      }
      const t = this.getFlightObjName(type);
      if (this[t] !== null) {
        return { label: this[t].fare.label };
      }
      return "";
    },
    getSelDepLoc() {
      return 5;
    },
    getSelDestLoc() {
      return 10;
    }
  },
  methods: {
    editBooking() {
      if (
        this.form_fields.b_id > 0 &&
        this.loading !== true
      ) {
        this.getEditBookingDetails({
          bid: this.form_fields.b_id
        });
      } else {
        console.log("Must enter b_id to edit");
      }
    },
    goHome() {
      this.goToUrl(process.env.VUE_APP_HOME_URL);
    },
    completeBooking() {
      const params = {
        action: this.editMode === true ? "update_booking" : "create_booking",
        user: this.user,
        fields: this.form_fields,
        dep: this.departFlight,
        ret: this.returnFlight,
        conditions: this.conditions,
        same_pax_returning: this.samepassengers
			};
      Payment.submitPayment(params);
      if(this.paymentError !== null)
      {
        this.$router.push({ path: "/booking/payment" });
      }
    },
    submitForm() {
      const path = this.$route.path;
      const index = this.getFormIndexByPath(path);
      if (
        this.testCompleteStep(index) === true &&
        this.errors.length === 0
      ) {
        this.setNextStep();
      } else {
        console.log("Incomplete - Submit blocked");
      }
    },
    keydown (evt) {
      if (!evt) evt = event;
      if (evt.keyCode === 13) {
        this.submitForm();
      }
      if (
        evt.altKey &&
        evt.keyCode === 68
      ) {
        if (store.state.devMode !== true) {
          store.commit("setDevMode", true);
        } else {
          store.commit("setDevMode", false);
        }
      }
    },
    handleInput() {
      this.dpInputDep();
      this.calDep = false;
    },
    addToCalendar() {
      if (this.form_fields.b_id > 0) {
        const url = process.env.VUE_APP_API_ICAL +
          "?bid=" +
          this.form_fields.b_id;
        this.goToUrl(url);
      }
    },
		newBookingButton() {
			this.goToUrl('/book-now/book-a-flight/');
		},
    cancelCreateAccount() {
      store.commit("unsetQuickErrors", "User Login");
      this.$router.push({ path: "/booking/account" });
    },
    createAccount() {
      const info = {
        action: "user_create",
        email: this.user.email,
        firstname: this.user.name_first,
        lastname: this.user.name_last,
        phone1: this.user.phone.cell,
        phone2: this.user.phone.alt,
        password: this.user.password
      };
      User.login(info);
    },
    createAccountRedir() {
      this.$router.push({ path: "/booking/account" });
    },
    login() {
      if (
        this.user.email !== undefined &&
        this.user.email !== "" &&
        this.user.password !== ""
      ) {
        User.login({
          action: "user_login",
          email: this.user.email,
          password: this.user.password
        });
      } else {
        console.log("already logged in - cancel login request");
      }
    },
    loginTest() {
      //if (store.state.user.id === null) {
        User.login({
          action: "user_data"
        });
      //}
    },
    logout() {
      store.commit("logoutUser: ", store.user);
      User.logout({
        action: "user_logout"
      });
      store.commit("setStepIncomplete", "Account");
      store.commit("setStepIncomplete", "Contact");
      store.commit("setStepIncomplete", "Summary");
      store.commit("setStepIncomplete", "Payment");
    },
    resetPassword() {
      const url = process.env.VUE_APP_FORGOT_PASSWORD;
      window.open(url);
    },
    openDialog(which) {
      store.commit("openDialog", which);
      window.scrollTo(0,0);
    },
    hideCalDep() {
      this.calDep = false;
    },
    hideCalRet() {
      this.calRet = false;
    },
    showHideForm() {
      store.commit("showHideForm");
    },
    validateSteps() {
      for (let x = 2; x <=7; x++) {
        this.validateStep(x);
      }
    },
    validateStep(step) {
      if (step === 2) {
        this.checkDiscounts();
        return this.validatePassengerDetails();
      } else if (step === 3) {
        return this.validateAccount();
      } else if (step === 4) {
        return this.validateContactInfo(store.state.user);
      } else if (step === 5) {
        return this.validateContactInfo();
      } else if (step === 6) {
        return this.validateTerms();
      } else if (step === 7) {
        return this.validatePayment();
      } else {
        console.log("No validation function for: ", step);
        return false;
      }
    },
    validateTerms() {
      if (this.form_fields.agree_to_terms === true) {
        this.completeSection("Summary");
      } else {
        store.commit("setStepIncomplete", "Summary");
      }
    },
    validateUser() {
      if (
        this.user.id !== null &&
        this.user.id > 1
      ) {
        return true;
      } else {
        return false;
      }
    },
    validatePayment() {
      // Use this to reload invoice when changing to prepaid?
      // this.getSummary();
      if (this.form_fields.use_prepaid === true) {
        if (this.user.id !== null) {
          console.log("Use prepaid - section complete");
          this.completeSection("Payment");
          return;
        } else {
          console.log("ERROR: Cannot use prepaid tickets without being logged in.");
          store.commit("setPrepaid", false);
        }
      }
      else if ( this.line_items.total === '0.00' ) {
        this.completeSection("Payment");
        return;
      } else {
        if (
          this.user.credit_card !== undefined &&
          this.user.credit_card.cvv !== null &&
          this.user.credit_card.cvv.length >= 3 &&
          this.user.credit_card.cvv.length <= 4 &&
          this.user.credit_card.expires.yy >= dayjs().format("YY") &&
          this.user.credit_card.expires.mm >= 1 &&
          this.user.credit_card.expires.mm <= 12 &&
          this.user.credit_card.number !== null &&
          this.user.credit_card.cardholder_fn !== null &&
					this.user.credit_card.cardholder_ln !== null
        ) {
          this.completeSection("Payment");
          return true;
        }
      }
      store.commit("setStepIncomplete", "Payment");
      return false;
    },
    validateContactInfo(user) {
      if (
        this.user.name_first.length > 1 &&
        this.user.name_last.length > 1 &&
        this.validatePhoneNumber(this.user.phone.cell) &&
        this.validateEmail(this.user.email)
      ) {
        this.completeSection("Contact");
        if (this.$route.name === "Login") {
          this.completeSection("Account");
        }
      } else {
        store.commit("setStepIncomplete", "Contact");
        return false;
      }
      return true;
    },
    validateAccount() {
      if (this.user.id !== null) {
        this.completeSection("Account");
      } else {
        store.commit("setStepIncomplete", "Account");
        return false;
      }
      return true;
    },
    validatePhoneNumber(num = false) {
      if (num !== false && num !== "") {
        const res = num.match(/\d/g);
        if (res !== null && res.length >= 10) return true;
      }
      return false;
    },
    validateEmail(email = false) {
      const regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
      if (
        email !== false &&
        email !== "" &&
        regex.test(email)
      ) {
        return true;
      }
      return false;
    },
    showSearchForm() {
      if (
        this.active === 1 ||
        (
          this.active === 2 &&
          this.form_fields.ret_date !== null
        )
      ) {
        this.showHideForm();
      } else if (this.active > 2) {
        if (store.state.showForm === false) {
          store.commit("showHideForm");
        }
        this.goToStep(0);
      }
    },
    resetForm() {
      console.log('Resetting Form');
      store.dispatch("RESET_FORM_DATA");
      this.$router.push({ path: "/" });
    },
    resetFormExceptDepart() {
      console.log('Resetting Form, except Departing');
      store.dispatch("RESET_FORM_DATA_EXCEPT_DEPART");
    },
    testStepErrors(which) {
      let error = false;
      if (!isNaN(which)) {
        if (this.testStepError(which) === true) {
          error = true;
        }
      } else {
        which.forEach(s => {
          if (this.testStepError(s)) {
            error = true;
          }
        });
      }
      return error;
    },
    testStepError(i) {
      if (i >= 0) {
        let step = this.form[0].children[i];
        if (step.meta.error === true) {
          return true;
        }
        if (step.meta.fields != undefined) {
          let fields = step.meta.fields;
          for (let x = 0; x < fields.length; x++) {
            if (fields[x].status.error === true) {
              return true;
            }
          }
        }
      }
      return false;
    },
    continueAsGuest() {
      this.completeSection("Account");
      this.$router.push({ path: "/booking/contact" });
      return;
    },
    testPreviousSteps(stepIndex) {
      let s = [];
      if (typeof stepIndex !== 'number') {
        stepIndex = this.getFormIndexByPath(stepIndex);
      }
      if (stepIndex > 0) {
        for (let x = 0; x < stepIndex; x++) {
          if (this.form[0].children[x].active === true) {
            s.push(x);
          }
        }
        return this.testCompleteGroup(s);
      } else {
        return this.testCompleteStep(0);
      }
    },
    testCompleteGroup(which) {
      if (which.length !== undefined) {
        let y = 0;
        which.forEach(w => {
          if (this.testCompleteStep(w) === true) {
            y++;
          }
        });
        if (y === which.length) {
          return true;
        }
      }
      return false;
    },
    testEditableStep(stepIndex = 0) {
      if (typeof stepIndex !== "number") {
        stepIndex = this.getFormIndexByPath(stepIndex);
      }
      if (
        store.state.complete === false &&
        store.state.errors.length === 0 &&
				(
					this.testPreviousSteps(stepIndex) === true ||
					stepIndex === 0
				)
      ) {
        return true;
      }
      return false;
    },
    testCompleteStep(step) {
      let f;
      if (isNaN(step)) {
        step = this.getFormIndexByPath(step);
        if (Array.isArray(step) === true) {
          f = this.form[0].children[step[0]].children[step[1]];
        } else {
          f = this.form[0].children[step];
        }
      } else {
        f = this.form[0].children[step];
      }
      const name = f.name;
      if (f !== undefined && f.active === true) {
        let incomplete = 0;
        if (f.meta.fields !== undefined) {
          f.meta.fields.forEach(field => {
            if (
              f.active === true &&
              store.state.form_steps_complete.find(c => {
                return field.label === c;
              }) === undefined
            ) {
              const label = field.label;
              if (
                label.indexOf("Return") !== -1 &&
                this.form_fields.ret_date === null
              ) {
                // console.log("IGNORE 1", field.label);
              } else {
                incomplete++;
              }
            }
          });
        } else if (
          store.state.form_steps_complete.find(c => {
            return f.name === c;
          }) === undefined
        ) {
          if (incomplete === 0) {
            if (
              name.indexOf("Return") !== -1 &&
              this.form_fields.ret_date === null
            ) {
              // console.log("IGNORE", name);
            } else {
              incomplete++;
            }
          }
        }
        if (incomplete > 0) {
          return false;
        } else {
          return true;
        }
      } else if (f.active === false) {
        return true;
      }
    },
    setPrepaid() {
      store.commit("setPrepaid", !store.state.user.has_prepaid);
    },
    setPreviousStep() {
      const path = this.$route.path;
      const index = this.getFormIndexByPath(path);
      const pIndex = index - 1;
      for (let x = pIndex; x >= 0; x--) {
        const f = this.form[0].children[x];
        if (
          f !== undefined &&
          f.active === true
        ) {
          const step = this.getStepByIndex(x);
          store.commit("setActiveStep", step);
          if (
            f.path.indexOf("/departing/") === -1 &&
            f.path.indexOf("/return") === -1
          ) {
            if (this.testEditableStep(f.path) === true) {
              this.$router.push({ path: f.path });
              return;
            } else {
              console.log("Navigation blocked: not editable: ", f.path);
              return;
            }
          } else {
            if (this.testEditableStep(step)) {
              let index = this.getFormIndexByStep(step);
              this.setNextStepQuery(index);
              return;
            } else {
              return;
            }
          }
        } else {
          if (this.form[x].active !== true) {
            // console.log("Prev Form INACTIVE: ", f.name);
          }
        }
      }
      store.commit("setActiveStep", 1);
      this.goToPath("/");
    },
    setNextStep() {
      const path = this.$route.path;
      const index = this.getFormIndexByPath(path);
      const nIndex = this.getNextStep(index);
      this.goToStep(nIndex);
		},
		getStepHideNextPrev() {
			const path = this.$route.path;
			if (path == '/booking/user/new')
			{
				return false;
			}
			else
			{
				return true;
			}
		},
    getStepNumberByPath(p) {
      let index = 1;
      let forms = this.form[0].children;
      for (let x = 0; x < forms.length; x++) {
        let form = forms[x];
        if (form.path === p) {
          return index;
        } else if (form.active === true) {
          index++;
        }
      }
    },
    restoreStep(step) {
      if (step > 1) {
        this.goToStep(
          this.getFormIndexByStep(
            step
          )
        );
        return;
      }
    },
    getStepByIndex(i) {
      const steps = this.form[0].children;
      let step = 0;
      for (let x = 0; x <= i; x++) {
        if (steps[x].active == true) {
          step++;
        }
      }
      return step;
    },
    getFormIndexByStep(step) {
      let forms = this.form[0].children;
      let sCount = 0;
      for (let x = 0; x <= step; x++) {
        if (forms[x].active === true) {
          sCount++;
          if (step === sCount) {
            return x;
          }
        }
      }
      return 0;
    },
		getFormIndexByPath(path) {
			// if (typeof path == "number") {
			// 	console.log("getFormIndexByPath", path);
			// }
			if (path === "/") return 0;
      const pRoot = path.toString().split("/");
      let searchTerm = "/";
      if (pRoot.length > 1) {
        searchTerm = pRoot[1];
        if (pRoot.length >= 3) {
          searchTerm += "/" + pRoot[2];
        }
      } else {
        searchTerm = path;
      }
      for (let x = 0; x < this.form[0].children.length; x++) {
        if (
          this.form[0].children[x].path === path ||
          this.form[0].children[x].path.indexOf(searchTerm) !== -1
        ) {
          return x;
        } else if (this.form[0].children[x].children !== undefined) {
          for (let y = 0; y < this.form[0].children[x].children.length; y++) {
            if (
              this.form[0].children[x].children[y].path === path ||
              this.form[0].children[x].children[y].path.indexOf(searchTerm) !== -1
            ) {
              return x;
            }
          }
        }
      }
      if (this.$route.name === "Departing") return 0;
    },
    goToUrl(url) {
      if (url.indexOf("http") === -1) {
        url = process.env.VUE_APP_HOME_URL + url;
      }
      window.location = url;
    },
    goToPath(p) {
      this.$router.push({ path: p });
    },
    goToStepHeader(stepIndex = 0)
    {
      if (typeof stepIndex !== "number") {
        if (stepIndex === "/") {
          this.goToPath("/booking/");
          return;
        }
        stepIndex = this.getFormIndexByPath(stepIndex);
      }
      const step = this.form[0].children[stepIndex];
      if(step.path === "/booking/payment")
      {
        console.log('aborting');
        this.form_fields.agree_to_terms = false;
        this.$router.push({ path: "/booking/summary" });
        return;
      }
      this.goToStep(stepIndex);
    },
    goToStep(stepIndex = 0) {
      if (typeof stepIndex !== "number") {
        if (stepIndex === "/") {
          this.goToPath("/booking/");
          return;
        }
        stepIndex = this.getFormIndexByPath(stepIndex);
      }
      const stepNum = this.getStepByIndex(stepIndex);
      const step = this.form[0].children[stepIndex];
      if (
        step !== undefined &&
        store.state.errors.length <= 0
      ) {
        const p = step.path;
        if (stepIndex === 0 || this.testPreviousSteps(stepIndex) === true) {
          if (this.testStepError(stepIndex) === false) {
            if (
              p.indexOf("/departing") === -1 &&
              p.indexOf("/return") === -1
            ) {
              if (this.testEditableStep(stepIndex)) {
                store.commit("setActiveStep", stepNum);
                this.$router.push({ path: p });
              } else {
              }
            } else {
              if (this.testEditableStep(stepIndex)) {
                this.setNextStepQuery(stepIndex);
              } else {
                console.log("Navigation blocked: not editable 2: ", step);
              }
            }
          }
        }
      } else {
        console.log(
          "Navigation blocked - error on page. step: ",
					step,
					"stepIndex",
					stepIndex,
					"form",
					this.form[0],
          "errors",
          store.state.errors
        );
      }
    },
    checkDiscounts() {
      let student = false;
      let senior = false;
      const flights = [
        this.departFlight !== null && this.departFlight.passengers !== undefined ? this.departFlight.passengers : null,
        this.returnFlight !== null && this.returnFlight.passengers !== undefined ? this.returnFlight.passengers : null
      ];
      flights.forEach(f => {
        if (f !== null && f.Adult !== undefined) {
          Object.keys(f.Adult).map(key => {
            if (f.Adult[key].discounts[0].value === true) student = true;
            else if (f.Adult[key].discounts[1].value === true) senior = true;
          });
        }
      });
      store.commit("setStudent", student);
      store.commit("setSenior", senior);
    },
    displayCountdownTimer() {
      const t = this.getRemainingTime();
      let min = t / 60;
      let dec = min.toString().split(".");
      let sec = t - (min * 60);
      if (dec[0] !== min) {
        min = dec[0];
        sec = Math.round(Number("." + dec[1]) * 60);
      }
      if (isNaN(sec)) sec = 0;
      if ((sec * 1) < 10) {
        sec = "0" + String(sec);
      }
      const time = min + ":" + sec;
      this.countdownTimer = time;
      EventBus.$emit("updateCountdownTimer", { time: time });
    },
    getRemainingTime() {
      if (store.state.timer === null) {
        console.log("TCL: getRemainingTime -> store.state.timer", store.state.timer);
        store.commit("setTimer", dayjs());
      }
      const tLimit = dayjs(store.state.timer)
        .add(
          store.state.timeLimit.value,
          store.state.timeLimit.scale
        );
      const now = dayjs();
      const diff = tLimit.diff(now, "second");
      return diff;
    },
    startTimer() {
      store.commit("setTimer", dayjs());
    },
    testFormTimeout(ticker = false) {
      if (this.complete === false) {
        if (
          store.state.timer === null ||
          this.complete === true
        ) {
          this.startTimer();
        }
        const remaining = this.getRemainingTime();
        if (
          remaining <= 0 &&
          this.complete !== true
        ) {
          console.log("Form Timeout - RESET FORM");
          this.resetForm();
          return;
        }
        if (ticker !== false) this.displayCountdownTimer();
      }
    },
    setReturn() {
      if (this.round_trip === false) {
        store.commit("setRetDate", null);
        this.calRet = false;
      } else {
        this.calRet = true;
        if (this.form_fields.ret_date !== null) {
          store.commit("setRetDate", this.form_fields.ret_date);
        } else if (this.form_fields.dep_date !== null) {
          store.commit("setRetDate", this.form_fields.dep_date);
        } else {
          store.commit("setRetDate", dayjs().format("YYYY-MM-DD"));
        }
      }
    },
    enabledDates(date) {
      var tDay = new Date(date);
      var yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
      if (dayjs(date).isAfter(dayjs().add("1", "year"))) {
        return false;
      } else {
        if (
          dayjs(tDay).isAfter(dayjs(yesterday).subtract(1, "day")) ||
          (
            dayjs(tDay).isSame(dayjs()) &&
            dayjs(tDay).hour() < 19
          )
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    enabledDatesReturn: date => {
      var tDay = dayjs(date).unix();
      var dDay = dayjs(store.state.form_fields.dep_date).unix();
      if (dayjs(date).isAfter(dayjs().add("1", "year"))) return false;
      else if (tDay >= dDay) return true;
    },
    isEmpty(value) {
      if (!value) return "Incomplete";
      else return true;
    },
    testDateBasic(date) {
      let now = dayjs();
      let d = dayjs(date);
      if (d.isValid()) {
        if (d.isSame(now, "day") || d.isAfter(now)) {
          if (d.isBefore(now.add("1", "year"))) {
            return true;
          }
        }
      }
      return false;
    },
    dpInputDep(val) {
      const t = this.testDates(val, this.ret_date);
      if (t !== true) {
        this.setError(t[0], t[1]);
      }
    },
    dpInputRet(val) {
      const t = this.testDates(this.dep_date, val);
      if (t !== true) {
        this.setError(t[0], t[1]);
      }
    },
    mInputDepDate(date) {
      let val = dayjs(date);
      if (this.testDateBasic(date) && val != this.dep_date) {
        store.commit("setDepartDate", val.format("YYYY-MM-DD"));
      } else {
        if (isNaN(val) || val == "" || val == null || val == undefined) {
          store.commit("setDepartDate", null);
        }
      }
    },
    getErrorIconSize() {
      let i = this.mobileDevice ? 100 : 400;
      return i;
    },
    printBooking(b_id=0) {
      // console.log("---PRINT PAGE---");
      if(b_id > 0)
    	{
				let domain = process.env.VUE_APP_CSA;
				let invoice_uri = domain + '/pdf/invoice_html/b_id/' + b_id;
        window.open( invoice_uri );
      }
      else
      {
        window.print();
      }
    },
    isMobileDevice() {
      let o = this.mobileDevice;
      let winW = window.innerWidth;
      let mobileDevice =
        typeof window.orientation !== "undefined" ||
        navigator.userAgent.indexOf("IEMobile") !== -1 ||
        winW < 850;
      if (o != mobileDevice) {
        this.mobileDevice = mobileDevice;
        const index = this.getStepIndex(this.$route.path);
        if (index === 0 || index === 1) {
          this.getLowestFares();
        }
      }
    },
    findPaxTerm(type = "departing", pax = false) {
      if (pax === false) {
        if (
          this.pax_a +
          this.pax_c +
          this.pax_i +
          this.pax_a_r +
          this.pax_c_r +
          this.pax_i_r  !== 1
        ) {
          return "Passengers";
        } else {
          return "Passenger";
        }
      } else {
        pax = "pax_" + pax;
        if (type !== departing) pax += "_r";
        if (this[pax] !== 1) {
          return "Passengers";
        } else {
          return "Passenger";
        }
      }
    },
    setGender(p, val) {
      this.$store.commit("setGender", [p.id, val]);
      this.validatePassengerDetails();
    },
    set_field(val) {
      this.$store.commit("set_field");
      this.validatePassengerDetails();
    },
    addPassenger(obj, dir, type, index) {
      let flight = dir + "Flight";
      if (
        this[flight].passengers[type][index] === undefined ||
        this[flight].passengers[type][index] === null
      ) {
        let p = new addPassengerPlaceholder(dir, index);
        const pax = [
          flight,
          type,
          index,
          p
        ];
        store.commit("addPassenger", pax);
      }
    },
    getFormFieldId(field, pid, index) {
      return field + "_" + pid + "_" + index;
    },
    compareRebookingData(data) {
      if (
        data.fields.dep_date !== undefined &&
        data.fields.dep_date === this.form_fields.dep_date &&
        Number(data.fields.dep_loc) * 1 === this.form_fields.dep_loc &&
        Number(data.fields.dest_loc) * 1 === this.form_fields.dest_loc &&
        Number(data.fields.pax_a) * 1 === this.form_fields.pax_a &&
        Number(data.fields.pax_c) * 1 === this.form_fields.pax_c &&
        Number(data.fields.pax_i) * 1 === this.form_fields.pax_i &&
        data.fields.round_trip === this.form_fields.round_trip
      ) {
        return true;
      }
      return false;
    },
    loadPassengerFields() {
      let oPax = {
        dep: null,
        ret: null,
      };
      if (this.editBookingData !== null) {
        oPax = {
          dep: this.editBookingData.dep.passengers,
          ret: this.editBookingData.ret.passengers,
        };
      }

      if (this.departFlight !== null) {
        const d = this.departFlight;
        const r = this.returnFlight;
        const a = this.pax_a;
        const o_a = oPax.dep !== null ? oPax.dep.Adult.length : -1;
        const c = this.pax_c;
        const o_c = oPax.dep !== null ? oPax.dep.Child.length : -1;
        const i = this.pax_i;
        const o_i = oPax.dep !== null ? oPax.dep.Infant.length : -1;
        const a_r = this.pax_a_r;
        const o_a_r = oPax.ret !== null ? oPax.ret.Adult.length : -1;
        const c_r = this.pax_c_r;
        const o_c_r = oPax.ret !== null ? oPax.ret.Child.length : -1;
        const i_r = this.pax_i_r;
        const o_i_r = oPax.ret !== null ? oPax.ret.Infant.length : -1;

        if (
          d.passengers === undefined ||
          d.passengers === null ||
          d.passengers.Adult === undefined
        ) {
          d.passengers = new passengerTypes();
        }
        if (
          r !== null &&
          (

            this.samepassengers === false
          )
        ) {
          r.passengers = new passengerTypes();
        }

        let type = "Adult";
        let count = d.passengers[type].length;
        let start = (count > 0) ? count - 1 : 0;
        let count_r, start_r;

        for (let y = start; y < a; y++) {
          if (y > o_a) {
            this.addPassenger(this, "depart", type, y);
          } else if (oPax.dep !== null) {
            store.commit("loadPaxObj", {
              name: "departFlight",
              type: "Adult",
              pax: oPax.dep.Adult
            });
          }
        }
				if (r != null && typeof r.passengers === "object" && typeof r.passengers[type] === "object" ) {
					let count_r = r.passengers[type].length;
					let start_r = (count_r > 0) ? count_r - 1 : 0;
					for (let y = start_r; y < a_r; y++) {
						if (y > o_a_r) {
							this.addPassenger(this, "return", type, y);
						} else {
							store.commit("loadPaxObj", {
								name: "returnFlight",
								type: "Adult",
								pax: oPax.ret.Adult
							});
						}
					}
        }
        type = "Child";
        if (d.passengers[type] !== undefined) {
          count = d.passengers[type].length;
          start = (count > 0) ? count - 1 : 0;
        } else {
          start = 0;
        }
        for (let y = start; y < c; y++) {
          if (y > o_c) {
            this.addPassenger(this, "depart", type, y);
          } else {
            store.commit("loadPaxObj", {
              name: "departFlight",
              type: "Child",
              pax: oPax.dep.Child
            });
          }
        }
        if (r !== null) {
          if (r.passengers[type] !== undefined) {
            count_r = r.passengers[type].length;
            start_r = (count_r > 0) ? count_r - 1 : 0;
          } else {
            start_r = 0;
          }
          for (let y = start_r; y < c_r; y++) {
            if (y > o_c_r) {
              this.addPassenger(this, "return", type, y);
            } else {
              store.commit("loadPaxObj", {
                name: "returnFlight",
                type: "Child",
                pax: oPax.ret.Child
              });
            }
          }
        }
        type = "Infant";
        if (d.passengers[type] !== undefined) {
          count = d.passengers[type].length;
          start = (count > 0) ? count - 1 : 0;
        } else {
          start = 0;
        }

        for (let y = start; y < i; y++) {
          if (y > o_i) {
            this.addPassenger(this, "depart", type, y);
          } else {
            store.commit("loadPaxObj", {
              name: "departFlight",
              type: "Infant",
              pax: oPax.dep.Infant
            });
          }
        }
        if (r != null) {
          if (r.passengers[type] !== undefined) {
            count_r = r.passengers[type].length;
            start_r = (count_r > 0) ? count_r - 1 : 0;
          } else {
            start_r = 0;
          }
          for (let y = start_r; y < i_r; y++) {
            if (y > o_i_r) {
              this.addPassenger(this, "return", type, y);
            } else {
              store.commit("loadPaxObj", {
                name: "returnFlight",
                type: "Infant",
                pax: oPax.ret.Infant
              });
            }
          }
        }
      }
    },
    getActivePassengers() {
      let fArr = [];
      let pArr = [];
      if (store.state.form_fields.ret_date !== null) {
        fArr = [this.departFlight, this.returnFlight];
      } else {
        fArr = [this.departFlight];
      }
      fArr.forEach((flight, i) => {
        if (flight != null && flight.passengers != undefined) {
          if (i === 0 || (i > 0 && this.samepassengers === false)) {
            Object.keys(flight.passengers).map(key => {
              let pGroup = flight.passengers[key];
              if (pGroup.length > 0) {
                pGroup.forEach(pass => {
                  pass.group = key;
                  pArr.push(pass);
                });
              }
            });
          }
        }
      });
      return pArr;
    },
    validatePassenger(p) {
      if (p.fname !== null && p.lname != null) {
        if (p.fname.length > 1 && p.lname.length > 1) {
          if (p.id >= 0) {
            if (p.group === "Adult") {
              if (p.gender !== "") {
                return true;
              }
            } else {
              return true;
            }
          }
        }
      }
      return false;
    },
    validatePassengerDetails() {
      let pass = this.getActivePassengers();
      let e = false;
      for (let x = 0; x < pass.length; x++) {
        if (this.validatePassenger(pass[x]) !== true) {
          store.commit("setStepIncomplete", "Passengers");
          return false;
        }
      }
      if (e === false) {
        this.completeSection("Passengers");
        store.dispatch("UNSET_ERRORS", "Passengers");
        return true;
      } else {
        return false;
      }
    },
    setError(label, msg) {
      store.commit("setStepIncomplete", label);
      store.commit("setErrorState", [label, msg]);
    },
    validatePassengers() {
      let a = { a: this.pax_a };
      let c = { c: this.pax_c };
      let i = { i: this.pax_i };
      let all_pax = [a, c, i];
      for (let x = 0; x < all_pax.length; x++) {
        let px = all_pax[x];
        for (var k in px) {
          let p = Number(px[k]);
          if (isNaN(p) || p > 9 || (k == "a" && p < 1) || (k != "a" && p < 0)) {
            this.setError("Passenger Count", "Invalid Passenger selection.");
            this.$store.commit("setStepIncomplete", "Passenger Count");
            return false;
          }
        }
      }
      if (this.validateInfants() !== true) {
        this.setError(
          "Passenger Count",
          "Special conditions apply to your booking. Infants generally require one adult each for accompanyment during the flight. " +
            'Please call us at <a class="black--text" href="tel:1-800-447-3247">1-800-447-3247</a> to book.'
        );
        return false;
      } else {
        this.$store.dispatch("UNSET_ERRORS", "Passenger Count");
        this.completeSection("Passenger Count");
        if (this.editMode !== true) {
          console.log("TCL: validatePassengers -> RESET FLIGHTS");
          this.resetFlights();
          if (this.form_fields.ret_date === null) {
            this.completeSection("Returning Passengers");
          } else {
            this.$store.commit("setReturningPassengers", all_pax);
          }
        }
        return true;
      }
    },
    validateInfants() {
      let a = Number(this.form_fields.pax_a);
      let i = Number(this.form_fields.pax_i);
      if (i <= a) {
        return true;
      }
      return false;
    },
    validatePassengersReturn() {
      let index = this.getFormIndexByPath(this.$route.path);
      let a = { a: this.pax_a_r };
      let c = { c: this.pax_c_r };
      let i = { i: this.pax_i_r };
      let all_pax = [a, c, i];

      for (let x = 0; x < all_pax.length; x++) {
        let px = all_pax[x];
        for (var k in px) {
          let p = Number(px[k]);
          if (isNaN(p) || p > 9 || (k == "a" && p < 1) || (k != "a" && p < 0)) {
            this.setError("Passenger Count", "Invalid Passenger selection.");
            this.$store.commit("setStepIncomplete", "Passenger Count");
            this.$store.commit("setStepIncomplete", "Return");
            return false;
          }
        }
      }
      if (this.validateInfantsReturn() !== true) {
        this.setError(
          "Returning Passengers",
          "Special conditions apply to your booking. Infants generally require one adult each for accompanyment during the flight. " +
            'Please call us at <a class="black--text" href="tel:1-800-447-3247">1-800-447-3247</a> to book.'
        );
        return false;
      } else {
        this.$store.dispatch("UNSET_ERRORS", "Returning Passengers");
        this.completeSection("Returning Passengers");
        this.setNextStepQuery(index);
        return true;
      }
    },
    validateInfantsReturn() {
      let a = Number(this.form_fields.pax_a_r);
      let i = Number(this.form_fields.pax_i_r);
      if (i <= a) {
        return true;
      }
      return false;
    },
    testFlightDates(flight, type) {
      let sel_flight = flight.flight_info.f_start;
      if (!dayjs(sel_flight).isAfter(dayjs().add("0", "hour"))) {
        return "Flights must be in the future.";
      }
      let this_flight =
        type == "departing" ?
          this.form_fields.dep_date :
            this.form_fields.ret_date;

      let that_flight = null;
      if (
        (this.returnFlight != null && type == "departing") ||
        (this.departFlight != null && type != "departing")
      ) {
        that_flight =
          type == "departing" ?
            this.returnFlight.departs :
              this.departFlight.departs;
      }
      if (that_flight != null) {
        if (type === "departing") {
          if (
            !dayjs(sel_flight).isBefore(
              dayjs(this.returnFlight.departs),
              "hour"
            )
          ) {
            return true;
          }
				} else {
					// returning
					
					// This should set a cut off 20 mins after the departing flight,
					// which is about the duration of a flight if someone wants to return immediately.

					// this.departFlight.departs = selected departing flight
					let return_cutoff_mins = 20;
					let return_cutoff = dayjs(this.departFlight.departs).add(return_cutoff_mins, 'minute');
					
					// sel_flight = current flight under review
          if (
						dayjs( return_cutoff ).isAfter( sel_flight ) === true
          ) {
            return "Return flights must occur after departing flight.";
          }
        }
      }
      return true;
    },
    completeSection(label) {
      store.commit("setStepComplete", label);
    },
    unCompleteSection(label) {
      store.commit("setStepIncomplete", label);
    },
    mInputRetDate(val) {
      const t = this.testDates(this.dep_date, val);
      if (t !== true) {
        this.setError(t[0], t[1]);
      }
      val = dayjs(val);
      if (this.testDateBasic(val) && val != this.ret_date) {
        store.commit("setRetDate", val.format("YYYY-MM-DD"));
      } else {
        if (isNaN(val) || val == "" || val == null || val == undefined) {
          store.commit("setRetDate", null);
        }
      }
    },
    testDates(departDate, returnDate = null) {
      var dDay = dayjs(departDate);
      var rDay = dayjs(returnDate);
      var now = dayjs();
      if (dDay.isValid()) {
        if (!dDay.isBefore(now) || dayjs(dDay).isSame(dayjs(now), "day")) {
          if (
            !rDay.isValid() ||
            dDay.isSame(rDay, "day") ||
            rDay.isAfter(dDay)
          ) {
            return true;
          } else {
            return ["Dates", "Return date must be after departure date."];
          }
        } else {
          return ["Dates", "Departure date must be in the future."];
        }
      } else {
        return ["Dates", "Departure date is required."];
      }
    },
    testLocations() {
      let dep_loc = this.form_fields.dep_loc * 1;
      let dest_loc = this.form_fields.dest_loc * 1;
      if (dep_loc >= 1 && dest_loc >= 1) {
        let dep = false;
        let dest = false;
        for (var x = 0; x < this.locations.length; x++) {
          if (dep_loc === this.locations[x].value) {
            dep = this.locations[x].name;
          } else if (dest_loc === this.locations[x].value) {
            dest = this.locations[x].name;
          }
        }
        if (dep !== undefined && dest !== undefined) {
          return true;
        }
      } else {
        store.commit("setStepIncomplete", "Locations");
        store.commit([
          "setErrorState",
          [
            "Locations",
            "Please select a departure and destination location to continue."
          ]
        ]);
        return false;
      }
      return false;
    },
    resetFlights() {
      if (this.editMode !== true) {
        store.dispatch("RESET_DEPART_FLIGHTS");
        this.resetReturnFlight();
        store.commit("setStepIncomplete", "Search Flights");
        store.commit("setStepIncomplete", "Departing");
        store.commit("setStepIncomplete", "Returning Passengers");
        store.commit("resetConditions");
      }
    },
    removeReturnFlight() {
      this.resetReturnFlight();
      store.commit("setRetDate", null);
      if (this.active >= 1) this.setNextStepQuery(1);
    },
    resetReturnFlight() {
      store.dispatch("RESET_RETURN_FLIGHTS");
      store.commit("setStepIncomplete", "Return");
    },
    formatDate(date) {
      return dayjs(date).format("dddd, MMMM D");
    },
    getDepartDate() {
      return this.form_fields.dep_date;
    },
		getDepartFlight() {
			return this.departFlight;
		},
    getDate() {
      if (this.searchType == "departing") {
        return this.formatDate(store.state.form_fields.dep_date);
      } else {
        return this.formatDate(store.state.form_fields.ret_date);
      }
    },
    formatPrice(amt) {
      if (typeof amt === "string" && amt !== "NaN") {
        if (amt.indexOf(",") !== -1) {
          amt = amt.replace(",", "");
        }
        amt = amt * 1;
        return "$" + amt.toFixed(2);
      } else if (Number.isInteger(amt) || !isNaN(amt)) {
        return "$" + amt.toFixed(2);
      } else {
        return "$0.00";
      }
    },
    amPm(time) {
      var hours = dayjs(time).hour();
      return hours >= 12 ? " PM" : " AM";
    },
    onSelect: function onSelect(items) {
      this.selected = items;
    },
    timeFormat(date, r_id = false) {
			if (r_id !== false) {
				var mins = 20;
				if (r_id == 37 || r_id == 38)
				{
					// Victoria - YHC route
					mins = 30;
				}
        date = dayjs(date).add(mins, "minutes");
      }
      return dayjs(date).format("h:mm") + this.amPm(date);
    },
    arrivalTime(flight) {
      let t = dayjs(flight)
        .add(25, "minute")
        .format("h:mm ");
      return t + this.amPm(flight);
    },
    getFlightInfo(f_id, type, key, subkey) {
      let t = this.getFlightsObjName(type);
      for (var x = 0; x < this[t].length; x++) {
        if (this[t][x].flight_info.f_id == f_id) {
          if (subkey) {
            return this[t][x][key][subkey];
          }
          return this[t][x][key];
        }
      }
    },
    getFlightObjName(type) {
      return type.split("ing")[0].toLowerCase() + "Flight";
    },
    getFlightsObjName(type) {
      return type.toLowerCase() + "Flights";
    },
    getLocationName(l_id) {
      for (var x = 0; x < this.locations.length; x++) {
        if (this.locations[x].value == l_id) {
          return this.locations[x].label;
        }
      }
    },
    get_city_name: function(loc_num) {
      for (var x = 0; x < this.locations.length; x++) {
        if (this.locations[x].value === loc_num) {
          return this.locations[x].label.replace("----", "");
        }
      }
      return "";
    },
    get_city_num: function(loc_name) {
      for (var x = 0; x < this.locations.length; x++) {
        if (this.locations[x].label == loc_name) {
          return this.locations[x].value;
        }
      }
      return "";
    },
    getAllFlightDescriptions() {
      let dArr = [
        {
          title: "Departing Flight",
          desc: this.description_departing(),
          pass: this.description_pass(),
          fare: this.description_fare("departFlight")
        },
        {
          title: "Return Flight",
          desc: this.description_returning(),
          pass: this.description_pass_ret(),
          fare: this.description_fare("returnFlight")
        },
        {
          title: "Total Cost",
          desc: this.description_total_cost()
        }
      ];
      let fD = {};
      for (let x = 0; x < dArr.length; x++) {
        fD[x] = dArr[x];
      }
      return fD;
    },
    description_total_cost() {
      let total = 0;
      const flights = ["departFlight", "returnFlight"];
      flights.forEach(f => {
        if (
          this[f] !== undefined &&
          this[f] !== null &&
          this[f].price !== undefined
        ) {
          total = Number(this[f].price.replace(",","")) + total;
        } else {
          return "";
        }
      });
      return this.formatPrice(total);
    },
    description_returning() {
      if (this.form_fields.ret_date !== null) {
        let rD = dayjs(this.form_fields.ret_date).format("dddd, MMMM D, YYYY");
        if (this.returnFlight !== null) {
					rD = dayjs(this.returnFlight.departs).format("dddd, MMMM D, YYYY h:mm a");
        }
        let ret = this.get_city_name(this.form_fields.dest_loc);
        const dest = this.get_city_name(this.form_fields.dep_loc);
        if (
          ret !== "" &&
          this.form_fields.dep_loc > 0
        ) {
          ret += ' <i aria-hidden="true" class="v-icon material-icons theme--light flight_desc_arrow">arrow_right_alt</i> ' +
            dest;
        } else {
          return "";
        }
        ret += "<br />" + rD;
        return ret;
      } else {
        return "";
      }
    },
    description_departing() {
      const d_city = this.description_departing_city();
      let ret = "";
      if (d_city !== "") {
        ret = d_city +
          ' <i aria-hidden="true" class="v-icon material-icons theme--light flight_desc_arrow">arrow_right_alt</i> ' +
          this.description_destination_city() +
          "<br />" +
          this.description_departing_date(true);
      }
      return ret;
    },
    description_departing_city(loc = 0) {
      if (loc == 0) return this.get_city_name(this.form_fields.dep_loc);
      else return this.get_city_name(this.form_fields.dest_loc);
    },
    description_destination_city() {
      return this.get_city_name(this.form_fields.dest_loc);
    },
    description_departing_date(time = false) {
      let dD = dayjs(this.form_fields.dep_date).format("dddd, MMMM D, YYYY");
      if (time === true) {
        dD = dayjs(this.form_fields.dep_date).format("dddd, MMMM D, YYYY");
        if (this.departFlight !== null) {
          dD = dayjs(this.departFlight.departs).format("dddd, MMMM D, YYYY, h:mm a");
        }
      } else {
        if (this.departFlight !== null) {
          dD = dayjs(this.departFlight.departs).format("dddd, MMMM D, YYYY");
        }
      }
      return dD;
    },
    description_departing_time() {
      if (this.departFlight !== null) {
        return dayjs(this.departFlight.departs).format("h:mm a");
      } else {
        return "";
      }
    },
    description_flight_type(type = "depart") {
      if (this[type + "Flight"] !== undefined && this[type + "Flight"] !== null) {
				if(this.form_fields.use_prepaid == true)
				{
					return 'Classic';
				}
				else
				{
        	return this[type + "Flight"].label;
				}
      }
      return "";
    },
    description_departing_flight() {
      if (this.departFlight !== null) {
        return this.departFlight.f_no;
      } else {
        return "";
      }
    },
    countPax(pax) {
      let count = 0;
      if (pax !== undefined) {
        const pass = Object.keys(pax);
        pass.forEach(x => {
          if (x !== "Infant" && pax[x].length > 0) {
            count += pax[x].length;
          }
        });
      }
      return count;
    },
    description_fees(dir = "depart") {
      const f = dir + "Flight";
      const flights = dir + "ingFlights";
      if (store.state[f] !== null) {
        let total_fees = 0;
        const flight_index = store.state[f].flight_index;
        const fare_index = store.state[f].fare_index;
        const flight = store.state[flights][flight_index];
        const pax = store.state[f].passengers;
        let pass = null;
        let pax_price_total = null;
        if (pax !== undefined) {
          pass = Object.keys(pax);
          pax_price_total = pax.price;
          const pax_count = this.countPax(pax);
          const feeTypes = ["in", "out"];
          const fares = flight.fares_available[fare_index];
          const info = flight.flight_info;
          const fees = info.f_fees;
          let feeArr = [];
          let sub_total = 0;
          let tax_total = 0;
          if (pass !== null) {
            pass.forEach(pType => {
              if (pax[pType].length > 0) {
                const t = pType.toLowerCase();
                const f = fares[t];
                let before_tax = 0;
                let total_before_tax = 0;
                let price_before_tax = 0;
                if (fares[pType.toLowerCase()] !== undefined) {
                  const price = fares[pType.toLowerCase()];
                  const total = price * 1 * pax[pType].length;
                  const tax = total / 1.05 * 0.05;
                  const price_tax = price / 1.05 * 0.05;
                  price_before_tax = price * 1 - price_tax;
                  tax_total += tax;
                  before_tax = total - tax;
                  sub_total += before_tax;
                  total_before_tax = price_before_tax * pax[pType].length;
                  total_fees += total;
                }
                let fee = {
                  name: pType,
                  pax: pax[pType],
                  num: pax[pType].length,
                  price: this.formatPrice(price_before_tax),
                  total: this.formatPrice(total_before_tax)
                };
                feeArr.push(fee);
              }
            });
            feeArr.push({
              name: "($3 online discount)",
              num: pax_count,
              price: "$3.00",
              total: this.formatPrice(3 * pax_count)
            });
            feeTypes.forEach(fT => {
              if (fees[fT] !== undefined) {
                fees[fT].forEach(f => {
                  const name = f.location + " " + f.name;
                  const price = f.amount;
                  const total_price = price * pax_count;
                  sub_total += total_price;
                  let fee = {
                    name: name,
                    num: pax_count,
                    price: this.formatPrice(price),
                    total: this.formatPrice(total_price)
                  };
                  feeArr.push(fee);
                });
              }
            });
          }
          feeArr.push({
            name: "Tax",
            num: null,
            price: null,
            total: this.formatPrice(tax_total)
          });
          feeArr.push({
            name: "Subtotal",
            num: null,
            price: null,
            total: this.formatPrice(total_fees)
          });
          return feeArr;
        }
      } else {
        return [];
      }
    },
    description_pax(dir = "depart") {
      let flight = dir + "Flight";
      if (this[flight] !== null) {
        if (
          this.samepassengers === true &&
          dir === "return"
        ) {
          flight = "departFlight";
        }
        const pax = this[flight].passengers;
        let pArr = [];
        if (this[flight].passengers !== undefined && this[flight].passengers !== null) {
          const keys = Object.keys(this[flight].passengers);
          for (const key of keys) {
            if (pax[key].length > 0) {
              pax[key].forEach(p => {
                if (p.type !== undefined) {
                  pArr.push(
                    p.fname +
                    " " +
                    p.lname +
                    " (" +
                    key +
                    " " +
                    p.gender +
                    ")"
                  );
                }
              });
            }
          }
        }
        return pArr;
      } else {
        return "";
      }
    },
    description_returning_city(loc = 0) {
      if (this.form_fields.ret_date !== null) {
        if (loc == 0) return this.get_city_name(this.form_fields.dest_loc);
        else return this.get_city_name(this.form_fields.dep_loc);
      } else {
        return "";
      }
    },
    description_returning_date(time = false) {
      let dD = dayjs(this.form_fields.ret_date).format("dddd, MMMM D, YYYY");
      if (time === true) {
        dD = dayjs(this.form_fields.ret_date).format("dddd, MMMM D, YYYY h:mm a");
        if (this.returnFlight !== null) {
          dD = dayjs(this.returnFlight.departs).format("dddd, MMMM D, YYYY h:mm a");
        }
      } else {
        if (this.returnFlight !== null) {
          dD = dayjs(this.returnFlight.departs).format("dddd, MMMM D, YYYY");
        }
      }
      return dD;
    },
    description_returning_time() {
      if (this.returnFlight !== null) {
        return dayjs(this.returnFlight.departs).format("h:mm a");
      } else {
        return "";
      }
    },
    description_returning_flight() {
      if (this.returnFlight !== null) {
        return this.returnFlight.f_no;
      } else {
        return "";
      }
    },
    description_pass_ret() {
      var ret = 0;
      if (this.samepassengers === true) {
        if (this.form_fields.pax_a > 0) {
          if (this.form_fields.pax_a >= 1) {
            ret += this.form_fields.pax_a * 1;
          }
          if (this.form_fields.pax_c >= 1) {
            ret += this.form_fields.pax_c * 1;
          }
          if (this.form_fields.pax_i >= 1) {
            ret += this.form_fields.pax_i * 1;
          }
        }
      } else {
        if (this.form_fields.pax_a_r > 0) {
          if (this.form_fields.pax_a_r >= 1) {
            ret += this.form_fields.pax_a_r * 1;
          }
          if (this.form_fields.pax_c_r >= 1) {
            ret += this.form_fields.pax_c_r * 1;
          }
          if (this.form_fields.pax_i_r >= 1) {
            ret += this.form_fields.pax_i_r * 1;
          }
        }
      }
      return ret !== 1 ? ret + " Passengers" : ret + " Passenger";
    },
    description_pass() {
      var ret = 0;
      if (this.form_fields.pax_a > 0) {
        if (this.form_fields.pax_a >= 1) {
          ret += this.form_fields.pax_a * 1;
        }
        if (this.form_fields.pax_c >= 1) {
          ret += this.form_fields.pax_c * 1;
        }
        if (this.form_fields.pax_i >= 1) {
          ret += this.form_fields.pax_i * 1;
        }
      }
      return ret !== 1 ? ret + " Passengers" : ret + " Passenger";
    },
    description_fare(flightType) {
      const flight = this[flightType];
      if (flight !== null) return flight.label;
      else return "";
		},
		// promocode_amount_desc() {
		// 	return store.line_items.promocode_amount;
		// },
    isValidFlight(flightType, flight, fare) {
      if (
        this.conflictsWithSelection(flightType, flight) === true ||
        fare.fare_type === "call"
      ) {
        return false;
      }
      return true;
    },
    hideErrorDialog() {
      store.commit("showError");
    },
    conflictsWithSelection(flightType, flight) {
      const test = this.testFlightDates(flight, flightType);
      if (test === true) {
        return false;
      }
      return true;
    },
    getRouteQuery(params) {
      let newParams = {};
      if (
        Number.isInteger(params.start_loc * 1) &&
        Number.isInteger(params.end_loc * 1) &&
        params.start_loc >= 0 &&
        params.start_loc <= 100 &&
        params.end_loc >= 0 &&
        params.end_loc <= 100
      ) {
        newParams.from = params.start_loc * 1;
        newParams.to = params.end_loc * 1;
        if (
          params.range_start !== undefined &&
          this.testDates(params.range_start)
        ) {
          newParams.date = dayjs(params.range_start).format("YYYY-MM-DD");
          if (params.way_type === "round_trip") {
            if (this.testDates(params.return_date) === true) {
              newParams.return = dayjs(params.return_date).format("YYYY-MM-DD");
              this.completeSection("Returning Passengers");
            } else {
              console.log("INVALID RETURN DATE: ", params.return_date);
            }
          } else {
            newParams.return = null;
            this.completeSection("Return");
            this.completeSection("Returning Passengers");
          }
				} else {
					newParams.date = dayjs().format("YYYY-MM-DD");
          console.log("INVALID START DATE: ", params.range_start);
        }
        let a = {};
        let c = {};
        let i = {};
        if (params.pax_a !== undefined) {
          a = { a: params.pax_a * 1 };
          c = { c: params.pax_c * 1 };
          i = { i: params.pax_i * 1 };
        } else {
          a = { a: store.state.form_fields.pax_a * 1 };
          c = { c: store.state.form_fields.pax_c * 1 };
          i = { i: store.state.form_fields.pax_i * 1 };
        }
        newParams.pax = [a, c, i];
        store.dispatch("LOAD_URL_PARAMS", newParams);
        this.completeSection("Locations");
        this.completeSection("Passenger Count");
        this.completeSection("Dates");
        return newParams;
      } else if (params.to !== undefined) {
        this.setupParams(params);
      } else {
        console.log("routeQuery FAILURE");
      }
    },
    setupParams(params) {
      let newParams = {};
      if (params.to !== undefined) {
        if (
          params.to !== ""  &&
          params.from !== undefined &&
          params.from !== ""
        ) {
          newParams.to = this.get_city_num(params.to);
          newParams.from = this.get_city_num(params.from);

        } else {
          console.log("Invalid location parameter");
          return;
        }
        if (
          params.date !== undefined &&
          this.testDates(params.date)
        ) {
          newParams.date = dayjs(params.date).format("YYYY-MM-DD");
        } else {
          if (
            store.state.form_fields.dep_date !== null &&
            store.state.active === 1
          ) {
            newParams.date = store.state.form_fields.dep_date;
          } else {
            console.log("Missing or invalid date parameter");
            return;
          }
        }
        if (
          params.return !== undefined &&
          params.return !== false &&
          this.testDates(params.return) === true
        ) {
          newParams.return = dayjs(params.return).format("YYYY-MM-DD");
          if (params.return === "Invalid Date") {
            this.completeSection("Return");
            this.completeSection("Returning Passengers");
          }
        } else if (params.flight_type === "return") {
          if (this.testDates(params.return) !== true) {
            console.log("INVALID DATE", params);
            return;
          }
        }
      } else {
        console.log("Params are UNDEFINED", params);
        return;
      }
      let a = {};
      let c = {};
      let i = {};
      if (params.pax_a !== undefined) {
        a = { a: params.pax_a * 1 };
        c = { c: params.pax_c * 1 };
        i = { i: params.pax_i * 1 };
      } else {
        a = { a: store.state.form_fields.pax_a * 1 };
        c = { c: store.state.form_fields.pax_c * 1 };
        i = { i: store.state.form_fields.pax_i * 1 };
      }
      newParams.pax = [a, c, i];
      store.dispatch("LOAD_URL_PARAMS", newParams);
      this.completeSection("Locations");
      this.completeSection("Passenger Count");
      this.completeSection("Dates");
    },
    addSummaryParams() {
      var params = {};
      params.action = "invoice";
			params.use_prepaid = this.form_fields.use_prepaid;
			params.promocode = store.state.user.promocode;
      params.dep_f_id = this.departFlight.f_id;
      params.dep_f_no = this.departFlight.f_no;
      params.dep_f_type = this.departFlight.fare.fare_type.toLowerCase();
      params.dep_pax_a = this.form_fields.pax_a;
      params.dep_pax_c = this.form_fields.pax_c;
			params.dep_pax_i = this.form_fields.pax_i;
			params.b_id = this.form_fields.b_id;
      if (
        this.form_fields.ret_date !== null &&
        this.returnFlight !== null
      ) {
        params.ret_f_id = this.returnFlight.f_id;
        params.ret_f_no = this.returnFlight.f_no;
        params.ret_f_type = this.returnFlight.fare.fare_type.toLowerCase();
        if (this.samepassengers === false) {
          params.ret_pax_a = this.form_fields.pax_a_r;
          params.ret_pax_c = this.form_fields.pax_c_r;
          params.ret_pax_i = this.form_fields.pax_i_r;
        } else {
          params.ret_pax_a = this.form_fields.pax_a;
          params.ret_pax_c = this.form_fields.pax_c;
          params.ret_pax_i = this.form_fields.pax_i;
        }
      }
      params.dep = this.departFlight;
      params.same_pax_returning = this.samepassengers;
      if (this.returnFlight !== null) {
        params.ret = this.returnFlight;
      }
      return params;
    },
    addCommonParams(params) {
      var f_params = [];
      if (params.flight_type === "returning") {
        f_params = flightsReturningParams;
        f_params.from = store.state.form_fields.ret_loc;
        f_params.from = store.state.form_fields.ret_date;
        f_params.date = store.state.form_fields.ret_date;
        f_params.ret_date = store.state.form_fields.ret_date;
        f_params.start_loc = store.state.form_fields.dest_loc;
        f_params.end_loc = store.state.form_fields.dep_loc;
        if (this.samepassengers !== true) {
          f_params.pax_a = store.state.form_fields.pax_a_r;
          f_params.pax_c = store.state.form_fields.pax_c_r;
          f_params.pax_i = store.state.form_fields.pax_i_r;
        } else {
          f_params.pax_a = store.state.form_fields.pax_a;
          f_params.pax_c = store.state.form_fields.pax_c;
          f_params.pax_i = store.state.form_fields.pax_i;
        }
      } else {
        f_params = flightsDepartingParams;
        if (this.$route.params.to !== undefined) {
          this.setupParams(this.$route.params);
        } else if (this.$route.query.start_loc !== undefined) {
          this.getRouteQuery(this.$route.query);
        }
        f_params.date = store.state.form_fields.dep_date;
        f_params.dep_date = store.state.form_fields.dep_date;
        f_params.start_loc = store.state.form_fields.dep_loc;
        f_params.end_loc = store.state.form_fields.dest_loc;
        f_params.pax_a = store.state.form_fields.pax_a;
        f_params.pax_c = store.state.form_fields.pax_c;
        f_params.pax_i = store.state.form_fields.pax_i;
      }
      f_params.action = "flight_search";
      return f_params;
    },
    getSelectedClass(
      flight_index,
      fare_index,
      flight_type,
      num_flights,
      flight,
      fare
    ) {
      if (
        fare.fare_type === 'call' &&
        this.isValidFlight(flight_type, flight, fare) === true
      ) {
        return "call";
      }
			if (this.isValidFlight(flight_type, flight, fare) !== true) {
				return "invalid";
			}
      if (flight_type === "Waitlist") {
        return "waitlist";
      }
      if (
        this.departFlight !== null &&
        flight_index === this.departFlight.flight_index &&
        fare_index === this.departFlight.fare_index &&
        flight_type === "departing"
      ) {
        if (fare_index < num_flights - 1) {
          return "btm_brdr selected";
        }
        return "selected";
      } else if (
        this.returnFlight != null &&
        flight_index == this.returnFlight.flight_index &&
        fare_index == this.returnFlight.fare_index &&
        flight_type == "returning"
      ) {
        return "selected";
      }
      if (fare_index < num_flights - 1) {
        return "btm_brdr";
      }
      return "";
    },
    validatePassengersSeating(seats) {
      let p = Number(this.form_fields.pax_a);
      if (
        this.active === 3 &&
        this.samepassengers === false &&
        this.form_fields.pax_a_r !== null
      ) {
        p = Number(this.form_fields.pax_a_r);
      }
      if (p <= seats) {
        return true;
      } else {
        return false;
      }
    },
    setErrorAlert(msg) {
      this.error = {
        details: msg
      };
      this.showError = true;
    },
		clearAllStudentSeniorSelections() {
			// reset all student and senior discounts

      /*

      departing and return share passengers when samepassengers is true
      therefore, can't remove departing pax discounts when departing isn't standard
      however, server can understand and show only what's needed
      so we may not actually need to uncheck discount boxes

     */
     return true;

      // Skip reset if selected flights are standard fares
			if(
        this.departFlight !== null &&
        this.departFlight.fare.fare_type === 'standard' &&
        (
          this.returnFlight === null ||
          this.returnFlight.fare.fare_type === 'standard'
        )
      )
      {
        return true;
      }

			if (
				this.departFlight !== null &&
				this.departFlight.passengers.Adult.length > 0
			) {
        for( let i = 0; i<this.departFlight.passengers.Adult.length; i++ )
				{
					this.departFlight.passengers.Adult[i].discounts[0].value = false;
					this.departFlight.passengers.Adult[i].discounts[1].value = false;
				}
        store.commit("checkPaxDiscountsDepart", this.departFlight.passengers);
			}
			if (
				this.returnFlight !== null &&
				this.returnFlight.passengers.Adult.length > 0
			) {
				for( let i = 0; i<this.returnFlight.passengers.Adult.length; i++ )
				{
					this.returnFlight.passengers.Adult[i].discounts[0].value = false;
					this.returnFlight.passengers.Adult[i].discounts[1].value = false;
				}
        store.commit("checkPaxDiscountsReturn", this.returnFlight.passengers);
			}

		},
    FlightSelect(flight_index, fare_index, flight, fare, type) {
      const t = this.getFlightObjName(type);
      if (this[type + "Flight"] !== null) {
        let e = this.testFlightDates(flight, type);
        if (e !== true) {
          console.log("ERROR", e);
          return false;
        }
      }
      const thisFlight = {
        type: type.split("ing")[0].toLowerCase(),
        f_id: flight.flight_info.f_id,
        f_no: flight.flight_info.f_no,
        label: fare.label,
        flight_index: flight_index,
        fare_index: fare_index,
        price: fare.total,
        departs: this.getFlightInfo(
          flight.flight_info.f_id,
          type,
          "flight_info",
          "f_start"
        ),
        fare: fare,
        fare_info: flight.flight_info
      };
      const origFlightName = type.split("ing")[0].toLowerCase() + "Flight";
      const origFlight = this[origFlightName];
      let oPax = {};
      if (
        origFlight !== null &&
        origFlight.passengers !== undefined
      ) {
        oPax = origFlight.passengers;
      }
      let uName = type.charAt(0).toUpperCase() + type.slice(1);
      store.commit("set" + uName + "Flight", thisFlight);
      if (type !== "departing") {
        this.completeSection(uName + " Passengers");
      } else {
        this.completeSection("Passenger Count");
      }
      if (uName.indexOf("Return") !== -1) {
        uName = uName.split("ing")[0];
      }
      this.completeSection(uName);
      if (this.editMode !== true) {
        this.loadPassengerFields(oPax);
      }
      this.form_fields.agree_to_terms = false;
      this.testCompleteStep(this.getFormIndexByPath('/summary'));
      this.clearAllStudentSeniorSelections();
    },
    searchDeparting(params) {
      params = this.addCommonParams(params);
      FlightSearch.getDepartingFlights(params);
    },
    searchReturning(params) {
      params = this.addCommonParams(params);
      FlightSearch.getReturningFlights(params);
    },
    getSummary() {
      FlightSearch.getBookingSummary(this.addSummaryParams());
    },
    getNextStep(index = 0) {
      const steps = this.form[0].children;
      let n = 0;
      for (let x = index + 1; x < steps.length; x++) {
        n++;
        if (steps[x] !== undefined && steps[x].active === true) {
          return index + n;
        }
      }
    },
    getStepNumberByIndex(index = 0) {
      const steps = this.form[0].children;
      let sNum = 0;
      for (let x = 0; x < steps.length; x++) {
        if (steps[x].active === true) {
          sNum++;
        }
        if (x === index) {
          break;
        }
      }
      return sNum;
    },
    getStepIndex(path) {
      const pRoot = path.split("/");
      const steps = this.form[0].children;
      let i = 0;
      let found = false;
      for (let x = 0; x < steps.length; x++) {
        if (steps[x].path === path) {
          found = x;
          break;
        } else if (steps[x].children !== undefined) {
          const s = steps[x].children;
          s.forEach(sub => {
            if (
              sub.path === path||
              sub.path.indexOf(pRoot[1]) !== -1
            ) {
              if (found === false) found = x;
            }
          });
        }
      }
      if (found !== false) {
        return found;
      } else {
        return 0;
      }
    },
    getEditBookingDetails(params) {
      if (Number(params.bid) > 1) {
        params.action = "load_booking";
        let response = EditBooking.getBookingDetails(params);
        response.then(function() {
          EventBus.$emit("editBookingDetailsLoaded", {});
        });
      }
    },
    setNextStepQuery(sIndex, reload = false) {
      if (sIndex === "return" && this.form_fields.round_trip === false) {
        this.$router.push({ path: "/booking/passengers" });
        return;
      } else if (sIndex === "return" && this.form_fields.round_trip === true) {
        sIndex = 1;
      } else if (sIndex === 1 && this.form_fields.round_trip === false) {
        this.$router.push({ path: "/booking/departing" });
        sIndex = 0;
      }
      const dir = (sIndex === 0) ? "D" : "R";
      const p = this.setupURLPath(dir);
      store.commit("setActiveStep", sIndex + 1);
      this.$router.push({ path: p });
      if (
        (sIndex === 0 || sIndex === 1) &&
        (
          this.loading !== true ||
          this.editMode === true
        ) &&
        this.dep_loc > 0 &&
        this.dest_loc > 0
      ) {
        this.searchFlights();
      }
    },
    setupURLPath(dir) {
      if (dir === "D") {
        let path = "/booking/departing/from/" +
          this.get_city_name(this.form_fields.dep_loc) +
          "/to/" +
          this.get_city_name(this.form_fields.dest_loc) +
          "/date/" +
          this.form_fields.dep_date +
          "/adults/" +
          this.form_fields.pax_a +
          "/children/" +
          this.form_fields.pax_c +
          "/infants/" +
          this.form_fields.pax_i;
        let rDate = false;
        if (this.form_fields.ret_date !== null) rDate = this.form_fields.ret_date;
        path += "/return/" + rDate;
        return path;
      } else if (dir === "R" && this.form_fields.ret_date !== null) {
        const rDate = this.form_fields.ret_date;
        let path = "/booking/return/from/" +
          this.get_city_name(this.form_fields.dest_loc) +
          "/to/" +
          this.get_city_name(this.form_fields.dep_loc) +
          "/date/" +
          rDate;
        if (this.samepassengers === true) {
          path += "/adults/" +
            this.form_fields.pax_a +
            "/children/" +
            this.form_fields.pax_c +
            "/infants/" +
            this.form_fields.pax_i;
        } else {
          path += "/adults/" +
            this.form_fields.pax_a_r +
            "/children/" +
            this.form_fields.pax_c_r +
            "/infants/" +
            this.form_fields.pax_i_r;
        }
        return path;
      } else if (this.form_fields.ret_date === null) {
        return this.form[0].children[this.active].path;
      } else {
        console.log("setupURLPath failed: " + dir);
      }
    },
    searchFlights(setIndex = false) {
      if (this.loading !== true) {
        const path = this.$route.path;
        let index = this.getFormIndexByPath(path);
        if (setIndex !== false) {
          index = setIndex;
        }
        if (index === 0) {
          this.searchDeparting(flightsDepartingParams);
        } else if (index === 1) {
          this.searchReturning(flightsReturningParams);
        }
        if (this.minMode !== true) {
          this.getLowestFares();
        }
      } else {
        // console.log("Already loading... search aborted");
      }
    },
    searchLowestFares(paramsArr) {
      for (let x = 0; x < paramsArr.length; x++) {
        if (paramsArr[x] !== undefined) {
          FlightSearch.getLowestFare(paramsArr[x]);
        }
      }
    },
    getLowestFares() {
      let date = dayjs(store.state.form_fields.dep_date);
      if (this.$route.params.date !== undefined) {
        date = dayjs(this.$route.params.date);
      } else if (this.$route.params.flight_type == "returning") {
        date = dayjs(store.state.form_fields.ret_date);
      }
      let dayArr = [];
      dayArr.push(this.getLowestFareParams(date.format("YYYY-MM-DD")));
      this.searchLowestFares(dayArr);
    },
    dateRange() {
      let winW = window.innerWidth;
      return (winW < 600) ? 4 : 7;
    },
    getLowestFareParams(date) {
      if (date !== "Invalid Date") {
        const today = dayjs();
        const numDays = this.dateRange();
        const start = Math.round(numDays / 2) - 1;
        let firstDate;
        for (let x = start; x >= 0; x--) {
          firstDate = dayjs(date).subtract(x, "days");
          if (
            firstDate.isSame(today, "day") ||
            firstDate.isAfter(today, "day")
          ) {
            break;
          }
        }
        if (this.$route.params.from !== undefined) {
          return {
            action: "flight_day_lowest",
            days: numDays,
            date: firstDate.format("YYYY-MM-DD"),
            pax_a: this.$route.params.pax_a,
            pax_c: this.$route.params.pax_c,
            pax_i: this.$route.params.pax_i,
            dir: this.getDir(),
            start_loc: this.get_city_num(this.$route.params.from),
            end_loc: this.get_city_num(this.$route.params.to)
          };
        } else if (store.state.form_fields.ret_date !== null) {
          return {
            action: "flight_day_lowest",
            days: numDays,
            date: dayjs(date).format("YYYY-MM-DD"),
            pax_a: store.state.form_fields.pax_a,
            pax_c: store.state.form_fields.pax_c,
            pax_i: store.state.form_fields.pax_i,
            dir: this.getDir(),
            start_loc: store.state.form_fields.dest_loc,
            end_loc: store.state.form_fields.dep_loc
          };
        }
      } else {
        console.log("INVALID DATE");
      }
    },
    getLowestFareParamsSingle(date) {
      if (date !== "Invalid Date") {
        if (this.$route.params.from !== undefined) {
          return {
            action: "flight_day_lowest",
            days: 1,
            date: dayjs(date).format("YYYY-MM-DD"),
            pax_a: this.$route.params.pax_a,
            pax_c: this.$route.params.pax_c,
            pax_i: this.$route.params.pax_i,
            dir: this.getDir(),
            start_loc: this.get_city_num(this.$route.params.from),
            end_loc: this.get_city_num(this.$route.params.to)
          };
        } else if (store.state.form_fields.ret_date !== null) {
          return {
            action: "flight_day_lowest",
            days: 1,
            date: dayjs(date).format("YYYY-MM-DD"),
            pax_a: store.state.form_fields.pax_a,
            pax_c: store.state.form_fields.pax_c,
            pax_i: store.state.form_fields.pax_i,
            dir: this.getDir(),
            start_loc: store.state.form_fields.dest_loc,
            end_loc: store.state.form_fields.dep_loc
          };
        }
      } else {
        console.log("INVALID DATE");
      }
    },
    ucFirst(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    selectDate(date) {
      const d = this.getDir();
      const flight = {
        D: ["depart", "dep_date"],
        R: ["return", "ret_date"]
      };
      if (d == "D") {
        flight.D[2] = date;
        flight.D[2] = store.state.form_fields.ret_date;
      } else {
        flight.D[2] = store.state.form_fields.dep_date;
        flight.D[2] = date;
      }
      store.commit("reset" + this.ucFirst(flight[d][0]) + "Flight");
      store.commit("setStepIncomplete", this.ucFirst(flight[d][0]) + "ing Flight");
      if (d == "D") {
        store.commit("setDeptDate", date);
        const rDate = store.state.form_fields.ret_date;
        if (
          rDate !== null ||
          dayjs(rDate).isBefore(dayjs(date))
        ) {
          store.commit("setDeptDate", date);
        }
      } else {
        store.commit("setRetDate", date);
      }
      if (this.active === 1 || this.active === 2) {
        this.reloadFlightSearch();
      }
    },
		reloadFlightSearch() {
			console.log("reloadFlightSearch");
      this.$router.push({ path: this.setupURLPath(this.getDir()) });
      if (
        this.loading !== true &&
        this.dep_loc > 0 &&
        this.dest_loc > 0 &&
        this.dep_loc !== this.dest_loc
      ) {
        console.log(
          "running search with dep:",
          this.dep_loc,
          "dest:",
          this.dest_loc
        );
        this.searchFlights();
      }
    },
    getDay(date) {
      return dayjs(date).format("dddd");
    },
    getMonth(date) {
      return dayjs(date).format("MMM D");
    },
    checkSelected(date) {
      if (this.$route.params.date === date) {
        return true;
      } else {
        return false;
      }
    },
    getNextDate(arr, dir) {
      const mid = arr.length / 2;
      const index = Math.round(mid);
      const first = arr[index];
      let nD;
      if (this.$route.params.date !== undefined) {
        nD = dayjs(this.$route.params.date);
      } else {
        arr.sort((a, b) => {
          return dayjs(a.date).isBefore(dayjs(b.date)) ? 0 : 1;
        });
        nD = dayjs(first.date);
      }
      if (dir !== "right") {
        nD = nD.subtract(1, "day");
      } else {
        nD = nD.add(1, "day");
      }
      const validDate = this.testDates(nD);
      if (validDate === true) {
        return nD.format("YYYY-MM-DD");
      } else {
        return "invalid";
      }
    },
    checkNextDate(dir = "right") {
      if (store.state.lowestFares[dir] !== undefined) {
        let lFares = store.state.lowestFares[dir];
        let newDate = this.getNextDate(lFares, dir);
        return newDate === "invalid" ? false : true;
      }
      return true;
    },
    getDir() {
      const dir = this.active === 1 ? "D" : "R";
      return dir;
    },
    rowShift(dir = "right") {
      const index = this.getFormIndexByPath(this.$route.path);
      if (dir === "right") {
        if (index === 0) {
          store.commit("setDeptDate", dayjs(this.form_fields.dep_date).add(1, "day").format("YYYY-MM-DD"));
        } else if (index === 1) {
          store.commit("setRetDate", dayjs(this.form_fields.ret_date).add(1, "day").format("YYYY-MM-DD"));
        }
      } else if (dayjs(this.form_fields.dep_date).subtract(1, "day").isBefore(dayjs()) !== true) {
        if (index === 0) {
          store.commit("setDeptDate", dayjs(this.form_fields.dep_date).subtract(1, "day").format("YYYY-MM-DD"));
        } else if (index === 1) {
          store.commit("setRetDate", dayjs(this.form_fields.ret_date).subtract(1, "day").format("YYYY-MM-DD"));
        }
      } else {
        console.log("Lowest Fares: Cannot go to past dates");
        return;
      }
      if (index === 0 || index === 1) {
        this.setNextStepQuery(index);
      }
		},
		trackPurchase() {
			if (this.form_fields.round_trip == true)
			{
				window.gtag("event", "purchase", {
					transaction_id: this.form_fields.b_id, // Booking num
					value: this.line_items.total, // Sum of (price * quantity) for all items.
					currency: "CAD",
					items: [
						{
							// depart route
							item_name: this.get_city_name(this.form_fields.dep_loc) + " to " + this.get_city_name(this.form_fields.dest_loc)
						},
						{
							// return route
							item_name: this.get_city_name(this.form_fields.dest_loc) + " to " + this.get_city_name(this.form_fields.dep_loc)
						}
					]
				});
			}
			else
			{
				window.gtag("event", "purchase", {
					transaction_id: this.form_fields.b_id, // Booking num
					value: this.line_items.total, // Sum of (price * quantity) for all items.
					currency: "CAD",
					items: [
						{
							// depart route
							item_name: this.get_city_name(this.form_fields.dep_loc) + " to " + this.get_city_name(this.form_fields.dest_loc)
						}
					]
				});
			}

		},

  }
};
